import React from 'react';
import PropTypes from 'prop-types';
import { TextField } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { CONTRACT_BUY_INTL_PREFIX, GENERAL_ERROR_KEY } from './ContractBuy';
import styled from 'styled-components';

const NumberFieldNoArrows = styled(TextField)`
  input[type='number']::-webkit-inner-spin-button,
  input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`;

export const BuyVolumeInputField = ({ register, onBuyInputChange, name, disabled, errors }) => {
  const intl = useIntl();
  return (
    <NumberFieldNoArrows
      inputRef={register}
      label={intl.formatMessage({ id: `${CONTRACT_BUY_INTL_PREFIX}.${name}` })}
      name={name}
      variant={'outlined'}
      type={'number'}
      disabled={disabled}
      inputProps={{
        min: 0,
      }}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(event) => {
        onBuyInputChange(name, event);
      }}
      error={!!errors[GENERAL_ERROR_KEY]}
    />
  );
};

BuyVolumeInputField.propTypes = {
  register: PropTypes.func,
  onBuyInputChange: PropTypes.func,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  errors: PropTypes.object,
};
